/**
 * 
 */
(function(window, undefined) {
	"use strict";
	var UserSrvc = function() {
		this.user;
		this.abilitazioni;
		this.abilitazioniPronte;
		this.labelsPronte;
	};

	UserSrvc.$inject = [];

	angular.module("cbl.insuranceloanpmi.mf").service("UserSrvc", UserSrvc);
}(window));


//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/userSrvc.js
// module id = 36
// module chunks = 0 1